<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>研发专用价格档案</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 研发专用价格档案 strat -->
      <el-tab-pane name="first" label="研发专用价格档案">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.status" placeholder="请选择" class="select">
              <el-option label="请选择审核状态" value="-1"></el-option>
              <el-option label="研发已录入" value="1"></el-option>
              <el-option label="财务已审核" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.bomsn" placeholder="请选择产品" class="select2">
              <el-option label="请选择产品名称" value=""></el-option>
              <el-option
                v-for="item in optionsproduct" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.materialname" @keyup.enter.native="clicksearch" placeholder="请输入材料名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.suppliername" @keyup.enter.native="clicksearch" placeholder="请输入供应商名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="success" @click="clickmuban" plain>点击下载批量导入模板</el-button>
            <TencentyunCosUploadExcel @change="changeTencentyunCosUploadExcel" v-if="SubRule_ProductMoneyRd_Add"></TencentyunCosUploadExcel>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Productname" label="产品名称" min-width="10%"></el-table-column>
          <el-table-column prop="Statuss" label="审核状态" min-width="10%"></el-table-column>
          <el-table-column prop="Materialname" label="材料名称" min-width="13%"></el-table-column>
          <el-table-column prop="Suppliername" label="供应商名称" min-width="12%"></el-table-column>
          <el-table-column prop="Price" label="单价" min-width="10%"></el-table-column>
          <el-table-column label="附件" min-width="15%">
            <template v-slot="scope">
              <el-button v-for="Fileurl in scope.row.Fileurls" type="text" @click="clickfile(Fileurl)">点击查看</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="Beizhu" label="备注" min-width="10%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="10%"></el-table-column>
          <el-table-column prop="Operation" min-width="10%" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Status == 1" @click="clickedit(scope.$index,scope.row)">编辑</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Status == 1" @click="clickdelete(scope.$index,scope.row)">删除</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Status == 1 && SubRule_ProductMoneyRd_Caiwu" @click="clickShenHe(2,scope.row)">财务审核</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>

        <!-- 编辑研发专用价格档案弹出框 start -->
        <el-dialog title="编辑研发专用价格档案" :visible.sync="editdialog" width="30%" :close-on-click-modal="false">
          <el-form :model="editForm" ref="editFormRef" label-width="120px">
            <el-form-item label="材料名称" class="addAdminForm">
              <el-input v-model="editForm.materialname" placeholder="请输入材料名称"></el-input>
            </el-form-item>
            <el-form-item label="供应商名称" class="addAdminForm">
              <el-input v-model="editForm.suppliername" placeholder="请输入供应商名称"></el-input>
            </el-form-item>
            <el-form-item label="单价" class="addAdminForm">
              <el-input v-model="editForm.price" placeholder="请输入单价"></el-input>
            </el-form-item>
            <el-form-item label="附件" class="addAdminForm">
              <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="editTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
            </el-form-item>
            <el-form-item label="备注" class="addAdminForm">
              <el-input v-model="editForm.beizhu" placeholder="请输入备注"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="funsaveedit">保存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 编辑研发专用价格档案弹出框 end -->
      </el-tab-pane>
      <!-- 研发专用价格档案 end -->

      <!-- 添加研发专用价格档案 start -->
      <el-tab-pane name="second" label="添加研发专用价格档案" v-if="SubRule_ProductMoneyRd_Add">
        <el-form :model="addForm" ref="addFormRef" label-width="120px">
          <el-form-item label="产品名称" class="addAdminForm">
              <el-select v-model="addForm.bomsn" placeholder="请选择产品" class="select2">
                <el-option
                  v-for="item in optionsproduct" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="材料名称" class="addAdminForm">
            <el-input v-model="addForm.materialname" placeholder="请输入材料名称"></el-input>
          </el-form-item>
          <el-form-item label="供应商名称" class="addAdminForm">
            <el-input v-model="addForm.suppliername" placeholder="请输入供应商名称"></el-input>
          </el-form-item>
          <el-form-item label="单价" class="addAdminForm">
            <el-input v-model="addForm.price" placeholder="请输入单价"></el-input>
          </el-form-item>
          <el-form-item label="附件" class="addAdminForm">
            <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
          </el-form-item>
          <el-form-item label="备注" class="addAdminForm">
            <el-input v-model="addForm.beizhu" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="funsaveadd">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加研发专用价格档案 end -->

    </el-tabs>
  </div>
</template>

<script>
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
import TencentyunCosUploadExcel from '@/components/TencentyunCosUploadExcel.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadMultiImgOrPdf,
    TencentyunCosUploadExcel
  },
  name: 'MyProductMoneyRd',
  data () {
    return {
      keywords: {
        status: '-1',
        bomsn: '',
        materialname: '',
        suppliername: ''
      },
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      optionsproduct: [],
      addForm: {
        bomsn: '',
        materialname: '',
        suppliername: '',
        price: '',
        fileurl: '',
        beizhu: ''
      },
      editForm: {
        id: 0,
        materialname: '',
        suppliername: '',
        price: '',
        fileurl: '',
        beizhu: ''
      },
      editdialog: false,
      SubRule_ProductMoneyRd_Add: false,
      SubRule_ProductMoneyRd_Caiwu: false
    }
  },
  mounted () {
    this.apiGetWorkprojectList()

    this.apiGetproductmoneyrdnum()
    this.apiGetproductmoneyrdlist()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_ProductMoneyRd_Add', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ProductMoneyRd_Add = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ProductMoneyRd_Caiwu', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ProductMoneyRd_Caiwu = true
      }
    })
  },
  methods: {
    changeTencentyunCosUploadExcel (url) {
      if (this.keywords.bomsn == '') {
        this.$alert('请选择产品', '提示')
        return
      }
      this.apiExcelImportProductMoneyRd(url)
    },
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.addForm.fileurl = url
    },
    editTencentyunCosUploadMultiImgOrPdf (url) {
      this.editForm.fileurl = url
    },
    clickfile (url) {
      Vue.prototype.FunReviewFileurl(url, this.$router)
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetproductmoneyrdlist()
    },
    clickmuban () {
      window.open('https://erp-1256233047.cos.ap-shanghai.myqcloud.com/muban/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF%E7%A0%94%E5%8F%91%E4%B8%93%E7%94%A8%E4%BB%B7%E6%A0%BC%E6%A1%A3%E6%A1%88.xlsx')
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetproductmoneyrdnum()
      this.apiGetproductmoneyrdlist()
    },
    delaysearch () {
      var that = this
      setTimeout(function () {
        that.clicksearch()
      }, 2000)
    },
    clickdelete (index, row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDeleteproductmoneyrd(row.Id)
      })
    },
    funsaveadd () {
      if (!this.addForm.materialname) {
        this.$alert('请输入材料名称', '提示')
        return
      }
      if (!this.addForm.suppliername) {
        this.$alert('请输入供应商名称', '提示')
        return
      }
      if (!this.addForm.price) {
        this.$alert('请输入单价', '提示')
        return
      }
      this.apiAddproductmoneyrd()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickedit (index, row) {
      this.editForm.id = row.Id
      this.editForm.materialname = row.Materialname
      this.editForm.suppliername = row.Suppliername
      this.editForm.price = row.Price
      this.editForm.fileurl = row.Fileurl
      this.editForm.beizhu = row.Beizhu
      this.editdialog = true
    },
    clickShenHe (status, row) {
      this.$confirm('是否同意该价格档案?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiEditproductmoneyrdshenhe(status, row.Id)
      })
    },
    funsaveedit () {
      if (!this.editForm.materialname) {
        this.$alert('请输入材料名称', '提示')
        return
      }
      if (!this.editForm.suppliername) {
        this.$alert('请输入供应商名称', '提示')
        return
      }
      if (!this.editForm.price) {
        this.$alert('请输入单价', '提示')
        return
      }
      this.apiEditproductmoneyrd()
    },
    apiAddproductmoneyrd: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: this.addForm.bomsn,
        materialname: this.addForm.materialname,
        suppliername: this.addForm.suppliername,
        price: this.addForm.price,
        fileurl: this.addForm.fileurl,
        beizhu: this.addForm.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Addproductmoneyrd, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetproductmoneyrdnum()
            that.apiGetproductmoneyrdlist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetWorkprojectList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkprojectList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.optionsproduct = []
            response.data.List.filter((item1, i1) => {
              if (item1.Bomtype <= 1) {
                that.optionsproduct.push({ value: item1.Bomsn, label: item1.Name })
              }
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetproductmoneyrdlist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        status: that.keywords.status,
        bomsn: that.keywords.bomsn,
        materialname: that.keywords.materialname,
        suppliername: that.keywords.suppliername
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getproductmoneyrdlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            for (var i = 0; i < that.dataList.length; i++) {
              that.dataList[i].Fileurls = that.dataList[i].Fileurl.split('@@@')
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetproductmoneyrdnum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        status: that.keywords.status,
        bomsn: that.keywords.bomsn,
        materialname: that.keywords.materialname,
        suppliername: that.keywords.suppliername
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getproductmoneyrdnum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditproductmoneyrd: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.editForm.id,
        materialname: this.editForm.materialname,
        suppliername: this.editForm.suppliername,
        price: this.editForm.price,
        fileurl: this.editForm.fileurl,
        beizhu: this.editForm.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editproductmoneyrd, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiGetproductmoneyrdlist()
          }
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.editdialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDeleteproductmoneyrd: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Deleteproductmoneyrd, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiGetproductmoneyrdnum()
            that.apiGetproductmoneyrdlist()
          }
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditproductmoneyrdshenhe: function (status, id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id,
        status: status
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editproductmoneyrdshenhe, Qs.stringify(data))
        .then(function (response) {
          that.apiGetproductmoneyrdlist()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelImportProductMoneyRd: function (url) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: that.keywords.bomsn,
        fileurl: url
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelImportProductMoneyRd, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
          that.delaysearch()
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.el-tree{
  height: 350px;
  overflow-y: scroll
}
.el-tree::-webkit-scrollbar {
    display: none;
}
.select2{
    width: 100%;
}
</style>
